<template>
  <v-main class="app">
    <div class="headers">
      <div class="header-wrapper">
        <div class="main-header" v-if="!$vuetify.display.mobile">
          {{ $t('search.main_header') }}<br>
        </div>
        <div class="main-header mobile" v-else>
          {{ $t('search.main_header_mobile') }}<br>
        </div>
      </div>
      <div class="header-wrapper">
        <div class="sub-header" v-if="!$vuetify.display.mobile">
          <span v-html="$t('search.sub_header')" /> 
        </div>
        <div class="sub-header mobile" v-else>
          {{ $t('search.sub_header_mobile') }}
          <br><br>
        </div>
      </div>
      <div v-if="$vuetify.display.mobile && !oidcUser"
        class="header-wrapper d-flex justify-space-between flex-wrap-reverse mx-4">
        <v-btn class="signup_mobile_button menu_button mb-2"
          height="48"
          @click="goToRegistration"
          color="primary"
          variant="outlined">
          <span>{{ $t('user.register_btn') }}</span>
        </v-btn>
        <v-btn class="mobile_button login_mobile_button menu_button mb-2"
          height="48"
          @click="redirect"
          rounded
          color="primary"
          variant="flat">
          <span>{{ $t('user.login_btn') }}</span>
        </v-btn>
      </div>
    </div>
    <div class="search-wrapper">
      <donor-search-component 
        :btn-show-filters-name="$t('search.go_to_search_btn')" 
        btn-show-filters-icon="search white" 
        btn-show-filters-class="ma-4 px-6" 
        style="transform: translateZ(10px);" />
    </div>
  </v-main>
</template>

<script>
import DonorSearchComponent from '../components/DonorSearchComponent.vue';
import { useStore } from 'vuex'
import { computed } from 'vue'

export default {
  components: {
    DonorSearchComponent
  },
  setup() {
    const store = useStore()
    const oidcUser = computed(() => store.getters['oidcStore/oidcUser'])
    return {
      oidcUser
    }
  },
  mounted() {
    this.$store.dispatch('breadcrumbModule/setRoute', [{
      name: 'breadcrumb.want_to_be_a_parent',
      url: `https://bank.invicta.pl${ this.$t('bank_invicta_path.planning_parenthood') }`,
      absolute: true
    },{
      name: 'breadcrumb.search',
      url: ''
    },])
    this.$store.dispatch('resultsModule/setSearchForSimilar', false);
  },
  methods: {
    redirect() {
      if (this.$keycloak.authenticated) {
        this.authenticateOidc()
      } else {
        this.$router.push({
            name: 'redirect',
            params: {
                mode: 'login',
                pathname: location.pathname
            }
        })
      }
    },
    redirectToRegisterUrl() {
      this.$router.push({
          name: 'redirect',
          params: {
              mode: 'simple',
              pathname: location.pathname,
              url: this.$keycloak.createRegisterUrl({locale: this.$i18n.locale})
          }
      })
    },
    authenticateOidc() {
      this.store.dispatch('oidcStore/authenticateOidc', this.$route.params.pathname)
    },
    signOutOidcSilent() {
      this.store.dispatch('oidcStore/signOutOidcSilent').then(
        () => {
          this.store.dispatch('signOutClear');
          this.$router.push({name: "search"});
        }
      )
    },
    goToRegistration() {
      if (this.$keycloak.realm != process.env.VUE_APP_AUTH_REALM_NAME) {
        this.$keycloak.init(this.$keycloakInitOptions).then(() => {
          this.redirectToRegisterUrl()
        })
      } else {
        this.redirectToRegisterUrl()
      }
    }
  }
}
</script>


<style lang="scss" scoped>
  .app {
    position: relative;
    background: transparent;
    .search-wrapper {
      position: relative;
      z-index: 10 !important;
      max-width: 792px;
      margin: 0 auto;
    }
    .headers {
      position: relative;
      z-index: 2;
      padding-bottom: 10px;
      overflow: hidden;
    }
  }
  .main-header {
    background: transparent;
    text-align: left;
    @include nsb-font-main-header;
    font-size: 18px;
    line-height: 27px;
    margin-left: 16px;
    margin-top: 24px;
    &-bold {
      background: url('../assets/svg/squiggle.svg');
      background-position: center bottom;
      background-repeat: no-repeat;
      padding-right: 5px;
    }
    &.mobile {
      font-size: 24px;
    }
  }

  .sub-header {
    position: relative;
    width: 996px;
    margin-top: 16px;
    // margin-bottom: 32px;
    text-align: left;
    @include nsb-font-header;
    font-size: 10px;
    line-height: 21px;
    position: relative;
    margin-left: 16px;
    &-bold {
      @include nsb-font-header-bold;
      font-size: 10px;
      position: relative;
      &.mobile {
        font-size: 14px;
        line-height: 24px;
      }
    }
    &.mobile {
      font-size: 14px;
        line-height: 24px;
      width: calc(100% - 48px);
    }
  }
  // i leave it here in case someone want
  // that abomination to be visible on
  // mobile browsers
  .header-image {
    z-index: 1;
    width: 170vw;
    position: absolute;
    top: 0px;
    transform: translateX(-50%);
  }

  .mobile_button {
    max-width: 156px;
  }

  @media (min-width: 996px) {
    .header-wrapper {
      position: relative;
      width: 100%;
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      // width: 100vw;

      &.mobile {
        font-size: 14px;
      }
    }
    .headers {
      padding-bottom: 60px !important;
      overflow: hidden;
      max-width: 726px;
      margin: 0 auto;
    }
    .header-image {
      z-index: 1;
      width: 100vw;
      position: absolute;
      top: 0px;
      transform: translateX(-50%);
    }
    .main-header {
      line-height: 46px;
      width: 996px !important;
      margin-top: 40px;
      margin-left: 0;
      font-size: 40px;
      &-bold {
        font-size: 40px;
      }
    }
    .sub-header {
      width: 996px !important;
      margin-top: 16px;
      margin-left: 0px;
      font-size: 14px;
      line-height: 21px;
      margin-bottom: 0;
      &-bold {
        font-size: 14px;
      }
    }
  }
</style>